import * as types from './actionTypes'

export function setReferralSite(referringSite) {
    return { type: types.SET_REFERRAL_SITE, referringSite }
}